import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import { generateGuestsText } from '../forms/GuestPicker'
import DateFormat from '../helpers/DateFormat'
import { APP_LANGUAGE } from '../../localized-urls'

export default function StickyHeaderDr({ locationTitle, dateFrom, dateTo, duration, guestsInRoom }) {
  let departureDate
  if(dateFrom && dateTo) {
    departureDate = dateFrom.substr(0, 4) === dateTo.substr(0, 4) ? moment(dateFrom).format('DD') : moment(dateFrom).locale(APP_LANGUAGE).format('DD MMM YYYY')
  }
  return (
    <div className='pt-sticky-top fixed' sticky-top='sticky-top' clickable='true' trigger='#la-main-filters' >
      <div className='search-wrapper'>
        <h5 className='title'>{ locationTitle }</h5>
        <div className='details'>
          <span><FormattedMessage id='dive_resorts' defaultMessage='Dive resorts' />,</span>
          <span>
            { !dateFrom || !dateTo ? (<FormattedMessage id='any_date' defaultMessage='any date' />)
              : (<Fragment>{ departureDate } - <DateFormat date={dateTo} format='DD MMM YYYY' />&nbsp;
                <FormattedMessage id='night_qty' values={
                  { qty: duration }
                } defaultMessage='{qty, plural, one {# night} other {# nights}}' />
                { guestsInRoom && guestsInRoom.rooms
                  ? <Fragment>, { generateGuestsText(guestsInRoom) }</Fragment> : '' }
              </Fragment>)
            }
          </span>
          <a className='action-edit pointer'>
            <FormattedMessage id='edit' defaultMessage='Edit' />
          </a>
        </div>
      </div>
    </div>
  )
}
